import {useMutation, type UseMutationOptions} from '@tanstack/react-query';
import {
	setAttributeVocabularyValue,
	type QueryError,
	type SetAttributeVocabularyValueResult,
	type SetAttributeVocabularyValueRequestOptions,
} from '../setAttributeVocabularyValue';
export * from '../setAttributeVocabularyValue';

export type SetAttributeVocabularyValueQueryOptions = Omit<
	UseMutationOptions<
		SetAttributeVocabularyValueResult,
		QueryError,
		SetAttributeVocabularyValueRequestOptions,
		SetAttributeVocabularyValueResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof setAttributeVocabularyValue;
};

/**
 * react-query wrapper for `setAttributeVocabularyValue`
 * @param queryKeyParams
 * @param options
 */
export const useReactQuerySetAttributeVocabularyValue = ({
	mutationFn = setAttributeVocabularyValue,
	...options
}: SetAttributeVocabularyValueQueryOptions = {}) =>
	useMutation<
		SetAttributeVocabularyValueResult,
		QueryError,
		SetAttributeVocabularyValueRequestOptions,
		SetAttributeVocabularyValueResult
	>({
		mutationFn,
		...options,
	});

export default useReactQuerySetAttributeVocabularyValue;
